import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

function Loading({ show }) {

    if (!show) return null;
    return (
        <Box textAlign="center" my={1}>
            <CircularProgress />
        </Box>
    );
}

Loading.propTypes = {
    show: PropTypes.bool.isRequired
}

export default Loading;
